import cn from "classnames";
import { hourToTimeSpan } from "helpers/date";
import React, { useEffect, useRef, useState } from "react";

const AudioPlayer = ({ currentAudio, accessUrlLink }) => {
    useEffect(() => {
        line.current.value = 0;
        return () => {
            audio.pause();
            stopListener();
        };
    }, []);

    const listener = useRef(null);
    const line = useRef(null);
    const [saveVolume, setSaveVolume] = useState(0);
    const [currentTime, setCurrentTime] = useState("0:00");
    const [fullTime, setFullTime] = useState("0:00");
    const [range, setRange] = useState(10);
    const [mute, setMute] = useState(false);
    const [audio] = useState(new Audio(accessUrlLink));
    const [playing, setPlaying] = useState(false);

    audio.oncanplay = () => audio.duration && setFullTime(hourToTimeSpan(audio.duration));

    const startListener = () => {
        const listenerId = setInterval(() => {
            const totaltime = audio.duration;
            const currenttime = audio.currentTime;
            const time = (currenttime * 100) / totaltime;
            line.current.value = time;
            setCurrentTime(hourToTimeSpan(audio.currentTime));
            if (Math.round(time) === 100 || currentAudio.current !== listener.current) {
                stopAudio();
                setCurrentTime(hourToTimeSpan(0));
                audio.currentTime = 0;
                line.current.value = 0;
            }
        }, 50);
        currentAudio.current = listenerId;
        listener.current = listenerId;
    };

    const stopListener = () => {
        clearInterval(listener.current);
    };

    const startAudio = () => {
        audio.play();
        startListener();
        setPlaying(true);
    };

    const stopAudio = () => {
        audio.pause();
        stopListener();
        setPlaying(false);
    };

    const play = () => (!playing ? startAudio() : stopAudio());

    const setVolume = (e) => {
        if (audio.muted) {
            audio.muted = false;
            setMute(false);
        }
        const value = e.target.value;
        audio.volume = value / 10;
        setRange(value);
    };

    const muteAudio = () => {
        if (audio.muted) {
            audio.muted = false;
            setMute(false);
            setRange(saveVolume);
        } else {
            audio.muted = true;
            setMute(true);
            setSaveVolume(range);
            setRange(0);
        }
    };

    const setStartAudio = (e) => {
        const value = e.target.value;
        const time = (value / 100) * audio.duration;
        audio.currentTime = time;
        line.current.value = value;
        setCurrentTime(hourToTimeSpan(time));
    };

    const playingClassName = cn("audio__play", { "audio__play--start": playing, "audio__play--stop": !playing });

    const muteClassName = cn("d-flex", { "icon-uEAA1-volume-mute": mute, "icon-uEAA0-volume-up": !mute });

    return (
        <div className="audio">
            <div className="d-flex align-items-center">
                <div onClick={play} className={playingClassName}></div>
                <div className="audio__time">
                    <div className="audio__time--item">{fullTime}</div>
                    <div className="audio__time--item">{currentTime}</div>
                </div>
                <div className="audio__bar">
                    <input type="range" max="100" min="0" ref={line} onChange={setStartAudio} />
                </div>
                <div className="audio__volume">
                    <div onClick={muteAudio} className="audio__volume--icon">
                        <i className={muteClassName} />
                    </div>
                    <div className="audio__volume--range">
                        <input type="range" max="10" min="0" value={range} onChange={setVolume} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudioPlayer;
